<template>
  <div>
    <register-credential-puntos-colombia
      ref="register"
      @refresh="refreshConfigs"
    />

    <show-credential-puntos-colombia
      ref="table"
      @terminales="openTerminales"
      @editar="editarConfiguracion"
    />

    <show-credential-terminales-puntos-colombia
      v-model="dialogTerminales"
      :config="selectedConfig"
    />
  </div>
</template>

<script>

  export default {

    components: {

      RegisterCredentialPuntosColombia: () => import('./components/RegisterCredentialPuntosColombia'),
      ShowCredentialPuntosColombia: () => import('./components/ShowCredentialPuntosColombia'),
      ShowCredentialTerminalesPuntosColombia: () => import('./components/ShowCredentialTerminalesPuntosColombia'),

    },

    data () {
      return {

        dialogTerminales: false,

        selectedConfig: {},

      }
    },
    methods: {

      refreshConfigs () {
        this.$refs.table.load()
      },

      openTerminales (item) {
        this.selectedConfig = item
        this.dialogTerminales = true
      },

      editarConfiguracion (item) {
        this.$refs.register.load(item)
      },

    },

  }

</script>
